module.exports = __webpack_public_path__ + "img/folder.f2e0d2e6.png";